
      let Page = require('/work/mapbox-gl-js-docs/docs/pages/example/center-on-symbol.js');
      Page = Page.default || Page;
      module.exports = {
        component: Page,
        props: {
  "frontMatter": {
    "hideFromSearchEngines": true
  }
}
      };
    